export default __webpack_public_path__ + "static/media/dashboardChart.28d28644.PNG";